import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

import { FormValidationService, ErrorHandlingService, ValidationError, GuidService } from 'core-lib';
import { AlertService, FormValidator } from 'core-lib';

import {
  PermitService, PermitDetailsModel, TransactionDetailsResponseData,
  PermitDetailsVehicleItemModel,
  WaterUsageItemModel,
  WaterUsageCreateResponseData,
  PermitDetailsTransactionItemModel
} from '../services/permit.service';

import * as moment from 'moment';
import * as _ from 'lodash';
import { FileAttachmentDetailsModel, FileListItemModel, FileListModel } from '../components/file-upload/file-upload.component';

@Component({
  selector: 'cli-water-usage-bulk',
  templateUrl: './water-usage-bulk.component.html',
  styleUrls: ['./water-usage-bulk.component.scss']
})
export class WaterUsageBulkComponent implements OnInit {

  private permit: PermitDetailsModel;
  private validator: FormValidator;
  public vm: WaterUsageBulkViewModel;
  private transaction: PermitDetailsTransactionItemModel;

  constructor(private formValidationSvc: FormValidationService,
    private errorHandilingSvc: ErrorHandlingService,
    private permitSvc: PermitService,
    private guidSvc: GuidService,
    private router: Router,
    private alertSvc: AlertService,
    private errorHandlingSvc: ErrorHandlingService,
    private route: ActivatedRoute
  ) {

    this.vm = new WaterUsageBulkViewModel();
    this.validator = this.formValidationSvc.getFormValidator(this.vm);
    this.vm.transactionId = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.vm.fileList = new FileListModel();
    if (this.permitSvc.model == null) {
      this.vm.isLoading = true;
    }

    let promises$ = [];

    let permit$ = this.permitSvc.getDetails().toPromise().then((data: PermitDetailsModel) => {

      this.permit = data;

      this.vm.businessName = data.permitDetails.clientName;
      this.vm.contactName = data.permitDetails.firstName + ' ' + data.permitDetails.lastName;
      this.vm.permitNo = data.permitDetails.permitNo;

    },
      (e) => { this.errorHandilingSvc.processHttpError(e); });

    promises$.push(permit$);


    if (this.vm.transactionId) {
      let transaction$ = this.permitSvc.getTransactions({ transactionId: this.vm.transactionId })
        .toPromise().then((data: TransactionDetailsResponseData) => {

          if (data.items.length > 0) {
            this.transaction = data.items[0];
          }

        },
          (e) => { });

      promises$.push(transaction$);
    }

    Promise.all(promises$).then(() => {

      this.loadData();

    }).finally(() => {
      this.vm.isLoading = false;
    });
  }

  public error(fieldName: string): string {
    return this.formValidationSvc.getErrorMessage(this.vm, fieldName);
  }


  public proceedYes() {

    this.vm.isLoading = true;
    this.save().then(() => {

      let filter = { skip: 0, take: 20 };

      return this.permitSvc.getTransactions(filter).toPromise()
        .then((data: TransactionDetailsResponseData) => {

          this.permitSvc.model.transactions = data.items;
          this.permitSvc.model.transactionCount = data.totalCount;

          this.alertSvc.success(environment.TOASTR_HEADER, 'The water usage record successfully created', 2000, true);

          this.router.navigate(['/app/transactions']);

        }, (e) => { });
    }, (e) => { })
      .finally(() => { this.vm.isLoading = false; });
  }

  public proceedCancel() {
    this.router.navigate(['/app/transactions']);
  }

  public loadData() {

    this.vm.fillLoads = null;
    this.vm.waterUsageId = this.guidSvc.getGuid();
    this.vm.vehicles = _(this.permit.vehicles)
      .filter((v: PermitDetailsVehicleItemModel) => v.status === 'Active')
      .map((v: PermitDetailsVehicleItemModel) => {

        let uv = new WaterUsageBulkVehicleModel();
        uv.vehicleId = v.vehicleId;
        uv.description = `${v.rego} (${v.capacity} L)  ${v.vehicleType || ''}`;
        uv.capacity = v.capacity;

        return uv;

      })
      .value();

    let time = moment().subtract(6, 'month').startOf('month');

    for (let i = 0; i < 6; i++) {
      time = time.add(1, 'months');

      let t = new WaterUsageBulkMonthModel();
      t.monthId = time.endOf('month').startOf('day').format('YYYY-MM-DD');
      t.description = time.endOf('month').format('MMMM YYYY');

      this.vm.months.push(t);
    }

    this.vm.usageRate = this.permit.currentRates.usageRate;

    if (this.transaction) {

      this.vm.waterUsageId = this.transaction.transactionId;
      let v = _.find(this.permit.vehicles, (n: PermitDetailsVehicleItemModel) => this.transaction.regoNo === n.rego);

      this.vm.vehicleId = v.vehicleId;

      this.vm.fillMonth = moment(this.transaction.fillDate).endOf('month').format('YYYY-MM-DD');
      this.vm.usage = this.transaction.volume;
      this.vm.fillType = this.transaction.fillType;
      if (this.transaction.fillType === 'Loads') {

        this.vm.fillLoads = this.transaction.volume / v.capacity;
        this.vm.fillLitres = 0;
      } else {
        this.vm.fillLoads = 0;
        this.vm.fillLitres =  this.transaction.volume;

      }
      this.vm.fileList.items = _.map(this.transaction.attachments, (f: FileAttachmentDetailsModel) => {
        let fm = new FileListItemModel();
        fm.fileId = f.fileId;
        fm.fileName = f.fileName;
        fm.fullUrl = f.fullUrl;
        return fm;
      });



    }
    else {

      this.vm.fillMonth = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');


      this.vm.usageCost = 0;
      this.vm.usage = 0;

      if (this.vm.vehicles && this.vm.vehicles.length > 0) {
        let v = this.vm.vehicles[0];
        this.vm.vehicleId = v.vehicleId;

      }
    }

    this.calculateCost();
  }



  public calculateCost() {

    let v = _.find(this.vm.vehicles, (n: WaterUsageBulkVehicleModel) => {
      return this.vm.vehicleId === n.vehicleId;
    });

    if (v == null) {
      this.vm.usage = 0;
      this.vm.usageCost = 0;

      return;
    }

    this.vm.usage = v.capacity;
    if (this.vm.fillType === 'Loads'){
      this.vm.usageCost = this.vm.fillLoads * this.vm.usage / 1000 * this.vm.usageRate;

      if (isNaN(this.vm.fillLoads)) {
        this.vm.usageCost = 0;
      }
    }
    if (this.vm.fillType === 'Litres'){
      this.vm.usageCost = this.vm.fillLitres / 1000 * this.vm.usageRate;

      if (isNaN(this.vm.fillLitres)) {
        this.vm.usageCost = 0;
      }
    }
  }

  public validate(vm: WaterUsageBulkViewModel): Promise<void> {
    vm.errors = [];

    this.validator.validateRequired('vehicleId', 'Vehicle');
    if (this.vm.fillType === 'Loads'){
      this.validator.validateRequired('fillLoads', 'Number of Fills');
    }
    if (this.vm.fillType === 'Litres'){
      this.validator.validateRequired('fillLitres', 'Number of litres');
    }
    this.validator.validateRequired('fillMonth', 'Month');

    if (vm.errors.length > 0) { return Promise.reject('Invalid Input'); }

    return Promise.resolve();
  }

  public save(): Promise<any> {

    return this.validate(this.vm).then(() => {

      let w = new WaterUsageItemModel();
      w.waterUsageId = this.vm.waterUsageId;
      w.vehicleId = this.vm.vehicleId;
      w.permitId = this.permit.permitDetails.permitId;
      w.location = '';
      if (this.vm.fillType === 'Loads'){
        w.fillLitres = 0;
      }
      if (this.vm.fillType === 'Litres'){
        w.fillLoads = 0;
      }
      w.usageDate = this.vm.fillMonth;
      w.fillLoads = this.vm.fillLoads;
      w.fillLitres = this.vm.fillLitres;
      w.fillType = this.vm.fillType;
      w.comment = '';

      w.isBulk = true;
      w.isCreatedByAdmin = false;
      w.isDoNotBill = false;

      let p$: Promise<WaterUsageCreateResponseData>;

      if (!this.transaction) {
        p$ = this.permitSvc.createWaterUsage(w).toPromise();
      }
      else {
        p$ = this.permitSvc.updateWaterUsage(w).toPromise();
      }

      return p$.then((data: WaterUsageCreateResponseData) => {

        return data;
      },
        (e) => {
          let errorMessage = this.errorHandlingSvc.processHttpError(e);
          return Promise.reject(errorMessage);
        });
    },
      (e) => { return Promise.reject(e); });

  }

}


export class WaterUsageBulkViewModel {

  constructor() {
    this.vehicles = [];
    this.months = [];
    this.fileList = new FileListModel();
    this.fillType = 'Loads';
    this.fillLitres = 0;
    this.fillLoads = 0;
  }

  public transactionId: string;
  public fileList: FileListModel;
  public isOpening: boolean;
  public isLoading: boolean;
  public businessName: string;
  public contactName: string;
  public permitNo: string;

  public waterUsageId: string;

  public vehicleId: string;
  public fillLoads: number;
  public fillLitres: number;
  public fillType: string;
  public fillMonth: string;

  public usageRate: number;
  public usageCost: number;
  public usage: number;

  public vehicles: WaterUsageBulkVehicleModel[];
  public months: WaterUsageBulkMonthModel[];

  public errors: ValidationError[];
  public header: string;

}


export class WaterUsageBulkVehicleModel {

  public vehicleId: string;
  public description: string;
  public capacity: number;
}

export class WaterUsageBulkMonthModel {

  public monthId: string;
  public description: string;
}
